module.exports = __webpack_public_path__ + "img/fr_success_5.ab73b502.png";